import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["event", "distance"]

  connect() {
    this.filterDistances()
  }

  filterDistances() {
    const eventId = this.eventTarget.value

    this.distanceTarget.querySelectorAll("option[data-event-id]").forEach((option) => {
      const matchesEvent = option.dataset.eventId === eventId
      option.hidden = !matchesEvent
      option.disabled = !matchesEvent
    })

    if (this.distanceTarget.selectedOptions[0]?.disabled) this.distanceTarget.value = ""
  }
}
